export default () => ({
    activeIndex: 0,

    init() {
        const boundOnScrollEnd = this.onScrollEnd.bind(this)

        this.onScrollEnd()
        window.addEventListener('resize', boundOnScrollEnd)
        window.addEventListener('scrollend', boundOnScrollEnd)

        this.$watch('activeIndex', (activeIndex) => {
            const navigationChildren =
                this.$refs.navigation.querySelectorAll('li')
            const activeNavigationChild = navigationChildren[activeIndex]
            const margin = navigationChildren[0].offsetLeft

            this.$refs.navigation.scrollTo({
                left: activeNavigationChild.offsetLeft - margin,
                behavior: 'smooth',
            })
        })
    },

    onScrollEnd() {
        const children = this.$refs.track.children
        let activeIndex = 0

        for (let i = 0; i < children.length; i++) {
            const child = children[i]
            const { top } = child.getBoundingClientRect()

            if (top > window.innerHeight / 2) {
                break
            } else {
                activeIndex = i
            }
        }

        this.activeIndex = activeIndex
    },
})
